import { Text, useBreakpointValue } from '@chakra-ui/react';

import * as AppLayout from 'components/AppLayout';
import { useGiftcard } from 'context/giftcard';
import { useGiftcardsPagesLayoutContent } from 'context/giftcardsPagesLayoutContent';

export const NotActivated = () => {
  const { giftcard } = useGiftcard();

  const { labels } = useGiftcardsPagesLayoutContent();

  const isMobile = useBreakpointValue([true, true, false], { ssr: true });

  return (
    <>
      <AppLayout.InfoRow
        rows={[
          {
            key: 'contextName',
            label: labels.context,
            value: giftcard.contextName,
          },
        ]}
      />

      <AppLayout.InfoRow
        rows={[
          {
            key: 'amount',
            label: labels.amount,
            value: giftcard.isDynamicAmount
              ? '-'
              : giftcard.activation.formatted.amount,
          },
          {
            key: 'expiresAt',
            label: labels.expiresAt,
            value: giftcard.formatted.expiresAt,
          },
        ]}
      />

      <AppLayout.InfoRow
        rows={[
          {
            key: 'shortId',
            label: labels.shortId,
            value: <Text fontFamily="code">{giftcard.shortId}</Text>,
          },
          {
            key: 'giftcardId',
            label: labels.giftcardId,
            value: <Text fontFamily="code">{giftcard.id}</Text>,
          },
        ]}
        hasDivider={!isMobile}
        dividerProps={{ borderStyle: 'dashed' }}
      />
    </>
  );
};
